var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-form',{attrs:{"action":_vm.addGK40HeizungsprofiProvider,"no-reset":""},on:{"submitted":function($event){return _vm.$emit('vendor-api-added', $event.result)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var formData = ref.formData;
var dirty = ref.dirty;
var busy = ref.busy;
var submit = ref.submit;
var errorMessages = ref.errorMessages;
return [_c('core-toast',{attrs:{"messages":errorMessages,"error":""}}),_c('ui-flex',[_c('ui-cell',{attrs:{"basis":1}},[_c('ui-form-field',{attrs:{"input":"ui-input-text","path":"label","label":"Beschriftung"}})],1),_c('ui-cell',{attrs:{"grow":0,"push-right":""}},[_c('ui-wizard-button',{attrs:{"busy":busy},on:{"click":submit}},[_vm._v("Anlegen")])],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }